import { Grid, Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './MenuFooter.css';
import { cleanSession, setSession } from '../../redux/slices/sessionSlice';
import { currencyFormatter } from '../../helpers/util';
import { getSessionBagsService } from '../../services/client/bagService';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import IconUser from './IconUser';


const MenuFooter = ({ loading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { hoster, nameUser, rol, email, bags, updateBalance } = useSelector(store => store.session);
  // const [hosterName, setHosterName] = useState('');
  const [showBalance, setShowBalance] = useState(false)
  
  useEffect(() => {
    if (location.search === '?session_expired')
      return;
    if (hoster)
      getSessionBagsService().then(bags => {
        dispatch(setSession({
          bags: bags.map(bag => ({
            id: bag.id,
            type: bag.type,
            balance: bag.saldo,
            earnings_scheme: bag.earnings_scheme,
          }))
        }))
        // setHosterName(bags[0]?.hoster?.identification)
      }).catch((e) => console.error(e))
    // eslint-disable-next-line
  }, [hoster, updateBalance])

  const closeSession = () => {
    dispatch(cleanSession())
    navigate('/')
  }

  return (
    <div className='menu-footer'>
      <div style={{ borderTop: '1px solid #FFFFFF', margin: '20px 10px' }} />
      {
        loading ? (
          <Grid container direction={'row'} columnSpacing={2} alignItems={'center'}>
            <Grid item >
              <Skeleton variant="rectangular" width={210} height={25} style={{ marginBottom: 4 }} />
              <Skeleton variant="rectangular" width={210} height={15} style={{ marginBottom: 4 }} />
              <Skeleton variant="rectangular" width={210} height={15} style={{ marginBottom: 4 }} />
              <Skeleton variant="rectangular" width={210} height={25} />
            </Grid>
          </Grid>
        ) : (
          <Grid container paddingX={'20px'} className='menu-footer-wrapper' direction={'row'} columnSpacing={2} alignItems={'center'} flexWrap={'nowrap'}>
            <Grid item justifyItems={'center'}>
              <IconUser name={nameUser} identification={hoster?.identification} />
            </Grid>
            <Grid item flexDirection={'column'}>
              <Grid item columnSpacing={2} flex={1}>
                <p className='menu-footer-info-name'>{hoster?.username || nameUser}</p>
                <p className='menu-footer-info-email'>{email}</p>
                <p className='menu-footer-info-user'>{rol?.name}</p>
              </Grid>
              {
                bags?.length > 0 && (
                  <Grid item container direction={'row'} columnSpacing={1} alignItems={'center'} >
                    <Grid item flex={1}>
                      {
                        bags?.map(bag => (
                          <p key={bag.id} className='menu-footer-info-bag' style={{ flex: 1 }} >Saldo {bag.type}: {showBalance ? currencyFormatter.format(bag.balance) : '**********'}</p>
                        ))
                      }
                    </Grid>
                    <Grid item justifyContent={'center'} alignItems={'center'} onClick={() => setShowBalance(!showBalance)}>
                      {showBalance ? <VisibilityOff /> : <Visibility />}
                    </Grid>
                  </Grid>
                )
              }
              <Grid item flex={1} >
                <p className='menu-footer-info-close-session' onClick={closeSession}>CERRAR SESIÓN</p>
              </Grid>
            </Grid>
          </Grid>
        )
      }
    </div>
  )
}

export default MenuFooter;